import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ListLayout1Component } from '@components/list/components/list-layout-1';
import { ListLayout2Component } from '@components/list/components/list-layout-2/list-layout-2.component';
import { ListLayout3Component } from '@components/list/components/list-layout-3/list-layout-3.component';
import { ListLayout } from '@components/list/config';
import { ComponentLoaderAbstract } from '@services/component-loader';
import { Layout } from '@shared/models';

@Component({
  selector: 'app-list',
  imports: [ListLayout2Component, ListLayout1Component, ListLayout3Component],
  templateUrl: './list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListComponent extends ComponentLoaderAbstract<Layout<ListLayout>> {
  readonly layout = ListLayout;
}
